import { render, staticRenderFns } from "./ImportLut.vue?vue&type=template&id=53b223a1&"
import script from "./ImportLut.vue?vue&type=script&lang=js&"
export * from "./ImportLut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports